import React from 'react';
import CuadroPaises from './CuadroPaises.js';
import CuadroTipoTorneo from './CuadroTipoTorneo.js';
import * as TipoTorneo from '../constantes/TipoTorneo.js';
import styles from './HomeTorneos.module.css';

export const CuadrosTipoTorneo = [
  { codigo: TipoTorneo.MUNDIAL, descripcion: 'Copa del Mundo', tipoParticipante: 'S' },
  { codigo: TipoTorneo.JUEGOS_OLIMPICOS, descripcion: 'Juegos Olímpicos', tipoParticipante: 'S' },
  { codigo: TipoTorneo.SUDAMERICANO, descripcion: 'Copa América', tipoParticipante: 'S' },
  { codigo: TipoTorneo.EUROCOPA, descripcion: 'Eurocopa', tipoParticipante: 'S' },
  { codigo: TipoTorneo.MUNDIAL_CLUBES, descripcion: 'Mundial de Clubes', tipoParticipante: 'C' },
  { codigo: TipoTorneo.COPA_LIBERTADORES, descripcion: 'Copa Libertadores', tipoParticipante: 'C' },
  { codigo: TipoTorneo.COPA_SUDAMERICANA, descripcion: 'Copa Sudamericana', tipoParticipante: 'C' },
  { codigo: TipoTorneo.CHAMPIONS_LEAGUE, descripcion: 'Champions League', tipoParticipante: 'C' },
  { codigo: TipoTorneo.EUROPA_LEAGUE, descripcion: 'Europa League', tipoParticipante: 'C' },
];

const HomeTorneos = (props) => {
  return (
    <div className={`${styles.base}`}>
      <div className={`${styles.cuadroTorneos}`}>
        <CuadroPaises
          titulo="Torneos locales"
          incluirPrincipales={true}
          pathLinks="/torneosPais/"
        />
      </div>
      <div className={`${styles.contenedorCuadros}`}>
        {CuadrosTipoTorneo.map((tipoTorneo, index) => (
          <CuadroTipoTorneo key={index} tipoTorneo={tipoTorneo} />
        ))}
      </div>
    </div>
  );
};

export default HomeTorneos;
